
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.421 9.558a2 2 0 01-2.842 0L.979 3.9C-.27 2.638.625.494 2.402.494H13.6c1.777 0 2.671 2.144 1.421 3.407L9.421 9.558z","fill":"#2F2F34"}})])
          )
        }
      }
    